module.exports = __webpack_public_path__ + "img/paragraph.335ac90f.svg";